import { ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading, SectionCta } from "./Reveal";
import { SITE_CONFIG } from "@/config/siteConfig";

const ITEMS = [
  { item: "[ITEM 1: e.g. Dedicated HIPAA-trained coordinator]", value: "[$VALUE]" },
  { item: "[ITEM 2: e.g. Cross-trained backup coverage]", value: "[$VALUE]" },
  { item: "[ITEM 3: e.g. Pipeline management in your CRM]", value: "[$VALUE]" },
  { item: "[ITEM 4: e.g. Follow-up and deposit collection]", value: "[$VALUE]" },
  { item: "[ITEM 5: e.g. Daily KPI scorecard and monthly financials]", value: "[$VALUE]" },
  { item: "[ITEM 6: e.g. Named account manager and weekly call reviews]", value: "[$VALUE]" },
];

export const OfferStack = () => (
  <section id="offer" data-testid="offer-section" className="py-24 md:py-36 bg-coal border-y border-black/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        eyebrow="The offer"
        title={
          <>
            Everything included. <span className="italic text-champagne">One flat monthly rate.</span>
          </>
        }
        copy="No per-lead fees. No surprises. The full back-office function, priced like the asset it is."
      />

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-7 border border-black/10 bg-obsidian shadow-sm">
          <div className="px-8 md:px-10 py-6 border-b border-black/10">
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-champagne">What's included</p>
          </div>
          <ul>
            {ITEMS.map((row, i) => (
              <li
                key={i}
                data-testid={`offer-item-${i}`}
                className="flex items-baseline justify-between gap-6 px-8 md:px-10 py-5 border-b border-black/5"
              >
                <span className="text-base text-pearl font-light">{row.item}</span>
                <span className="font-mono text-sm text-zinc-500 whitespace-nowrap">{row.value}</span>
              </li>
            ))}
            <li className="flex items-baseline justify-between gap-6 px-8 md:px-10 py-6 bg-champagne/5">
              <span className="text-base font-normal text-pearl">Total value</span>
              <span className="font-mono text-lg text-champagne" data-testid="offer-total-value">[TOTAL VALUE]</span>
            </li>
          </ul>
        </Reveal>

        <div className="lg:col-span-5 flex flex-col gap-6">
          <Reveal delay={0.1} className="flex-1">
            <div className="h-full border border-champagne/40 bg-gradient-to-b from-champagne/10 to-white p-8 md:p-10 shadow-[0_20px_60px_rgba(61,165,221,0.12)]" data-testid="guarantee-block">
              <ShieldCheck size={36} className="text-champagne" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-3xl font-light text-pearl">The guarantee</h3>
              <p className="mt-4 text-sm md:text-base text-zinc-500 leading-relaxed">
                [GUARANTEE TERMS PLACEHOLDER]
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="border border-black/10 bg-obsidian p-8 shadow-sm" data-testid="scarcity-block">
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-champagne mb-3">Limited onboarding</p>
              <p className="font-display text-2xl font-light text-pearl leading-snug">
                We onboard only {SITE_CONFIG.monthlyOnboardingCap} new practices per month.{" "}
                <span className="text-champagne">
                  {SITE_CONFIG.spotsLeft} spots left for {SITE_CONFIG.month}.
                </span>
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      <SectionCta id="offer" label="Claim my spot" />
    </div>
  </section>
);
